export const ROW_DEFAULT_GUTTER: [number, number] = [24, 24];
export const ROW_SM_GUTTER: [number, number] = [12, 12];